/*
 *
 *
 *
 *   Copyright (c) 2022. TinyMedic Pvt Ltd  - All Rights Reserved.
 *   This file is part of the API module  of the project: TinyMedic-Platform.
 *
 *
 *   Proprietary and confidential.
 *
 *   Unauthorized copying of this file, via any medium is strictly prohibited.
 *    Any resources of   TinyMedic-Platform can not be copied and/or distributed without the express permission of TinyMedic Pvt Ltd.
 *
 *
 *
 */

import React, { useEffect, useState } from 'react';
import { Link, useLocation, useNavigate } from 'react-router-dom';
import { Button, Col, Form, FormGroup, Input, InputGroup, Row, Table } from 'reactstrap';
import { JhiItemCount, JhiPagination, Translate, getPaginationState, translate } from 'react-jhipster';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faSort, faSortDown, faSortUp } from '@fortawesome/free-solid-svg-icons';
import { ASC, DESC, ITEMS_PER_PAGE, SORT } from 'app/shared/util/pagination.constants';
import { overridePaginationStateWithQueryParams } from 'app/shared/util/entity-utils';
import { useAppDispatch, useAppSelector } from 'app/config/store';

import { getEntities, searchEntities } from './gynaec-history.reducer';

export const GynaecHistory = () => {
  const dispatch = useAppDispatch();

  const pageLocation = useLocation();
  const navigate = useNavigate();

  const [search, setSearch] = useState('');
  const [paginationState, setPaginationState] = useState(
    overridePaginationStateWithQueryParams(getPaginationState(pageLocation, ITEMS_PER_PAGE, 'id'), pageLocation.search),
  );

  const gynaecHistoryList = useAppSelector(state => state.gynaecHistory.entities);
  const loading = useAppSelector(state => state.gynaecHistory.loading);
  const totalItems = useAppSelector(state => state.gynaecHistory.totalItems);

  const getAllEntities = () => {
    if (search) {
      dispatch(
        searchEntities({
          query: search,
          page: paginationState.activePage - 1,
          size: paginationState.itemsPerPage,
          sort: `${paginationState.sort},${paginationState.order}`,
        }),
      );
    } else {
      dispatch(
        getEntities({
          page: paginationState.activePage - 1,
          size: paginationState.itemsPerPage,
          sort: `${paginationState.sort},${paginationState.order}`,
        }),
      );
    }
  };

  const startSearching = e => {
    if (search) {
      setPaginationState({
        ...paginationState,
        activePage: 1,
      });
      dispatch(
        searchEntities({
          query: search,
          page: paginationState.activePage - 1,
          size: paginationState.itemsPerPage,
          sort: `${paginationState.sort},${paginationState.order}`,
        }),
      );
    }
    e.preventDefault();
  };

  const clear = () => {
    setSearch('');
    setPaginationState({
      ...paginationState,
      activePage: 1,
    });
    dispatch(getEntities({}));
  };

  const handleSearch = event => setSearch(event.target.value);

  const sortEntities = () => {
    getAllEntities();
    const endURL = `?page=${paginationState.activePage}&sort=${paginationState.sort},${paginationState.order}`;
    if (pageLocation.search !== endURL) {
      navigate(`${pageLocation.pathname}${endURL}`);
    }
  };

  useEffect(() => {
    sortEntities();
  }, [paginationState.activePage, paginationState.order, paginationState.sort, search]);

  useEffect(() => {
    const params = new URLSearchParams(pageLocation.search);
    const page = params.get('page');
    const sort = params.get(SORT);
    if (page && sort) {
      const sortSplit = sort.split(',');
      setPaginationState({
        ...paginationState,
        activePage: +page,
        sort: sortSplit[0],
        order: sortSplit[1],
      });
    }
  }, [pageLocation.search]);

  const sort = p => () => {
    setPaginationState({
      ...paginationState,
      order: paginationState.order === ASC ? DESC : ASC,
      sort: p,
    });
  };

  const handlePagination = currentPage =>
    setPaginationState({
      ...paginationState,
      activePage: currentPage,
    });

  const handleSyncList = () => {
    sortEntities();
  };

  const getSortIconByFieldName = (fieldName: string) => {
    const sortFieldName = paginationState.sort;
    const order = paginationState.order;
    if (sortFieldName !== fieldName) {
      return faSort;
    }
    return order === ASC ? faSortUp : faSortDown;
  };

  return (
    <div>
      <h2 id="gynaec-history-heading" data-cy="GynaecHistoryHeading">
        <Translate contentKey="tinyMedicRestApp.gynaecHistory.home.title">Gynaec Histories</Translate>
        <div className="d-flex justify-content-end">
          <Button className="me-2" color="info" onClick={handleSyncList} disabled={loading}>
            <FontAwesomeIcon icon="sync" spin={loading} />{' '}
            <Translate contentKey="tinyMedicRestApp.gynaecHistory.home.refreshListLabel">Refresh List</Translate>
          </Button>
          <Link to="/gynaec-history/new" className="btn btn-primary jh-create-entity" id="jh-create-entity" data-cy="entityCreateButton">
            <FontAwesomeIcon icon="plus" />
            &nbsp;
            <Translate contentKey="tinyMedicRestApp.gynaecHistory.home.createLabel">Create new Gynaec History</Translate>
          </Link>
        </div>
      </h2>
      <Row>
        <Col sm="12">
          <Form onSubmit={startSearching}>
            <FormGroup>
              <InputGroup>
                <Input
                  type="text"
                  name="search"
                  defaultValue={search}
                  onChange={handleSearch}
                  placeholder={translate('tinyMedicRestApp.gynaecHistory.home.search')}
                />
                <Button className="input-group-addon">
                  <FontAwesomeIcon icon="search" />
                </Button>
                <Button type="reset" className="input-group-addon" onClick={clear}>
                  <FontAwesomeIcon icon="trash" />
                </Button>
              </InputGroup>
            </FormGroup>
          </Form>
        </Col>
      </Row>
      <div className="table-responsive">
        {gynaecHistoryList && gynaecHistoryList.length > 0 ? (
          <Table responsive>
            <thead>
              <tr>
                <th className="hand" onClick={sort('id')}>
                  <Translate contentKey="tinyMedicRestApp.gynaecHistory.id">Id</Translate>{' '}
                  <FontAwesomeIcon icon={getSortIconByFieldName('id')} />
                </th>
                <th className="hand" onClick={sort('lmp')}>
                  <Translate contentKey="tinyMedicRestApp.gynaecHistory.lmp">Lmp</Translate>{' '}
                  <FontAwesomeIcon icon={getSortIconByFieldName('lmp')} />
                </th>
                <th className="hand" onClick={sort('menarche')}>
                  <Translate contentKey="tinyMedicRestApp.gynaecHistory.menarche">Menarche</Translate>{' '}
                  <FontAwesomeIcon icon={getSortIconByFieldName('menarche')} />
                </th>
                <th className="hand" onClick={sort('periodRegular')}>
                  <Translate contentKey="tinyMedicRestApp.gynaecHistory.periodRegular">Period Regular</Translate>{' '}
                  <FontAwesomeIcon icon={getSortIconByFieldName('periodRegular')} />
                </th>
                <th className="hand" onClick={sort('periodCycleInterval')}>
                  <Translate contentKey="tinyMedicRestApp.gynaecHistory.periodCycleInterval">Period Cycle Interval</Translate>{' '}
                  <FontAwesomeIcon icon={getSortIconByFieldName('periodCycleInterval')} />
                </th>
                <th className="hand" onClick={sort('parity')}>
                  <Translate contentKey="tinyMedicRestApp.gynaecHistory.parity">Parity</Translate>{' '}
                  <FontAwesomeIcon icon={getSortIconByFieldName('parity')} />
                </th>
                <th className="hand" onClick={sort('loss')}>
                  <Translate contentKey="tinyMedicRestApp.gynaecHistory.loss">Loss</Translate>{' '}
                  <FontAwesomeIcon icon={getSortIconByFieldName('loss')} />
                </th>
                <th className="hand" onClick={sort('pain')}>
                  <Translate contentKey="tinyMedicRestApp.gynaecHistory.pain">Pain</Translate>{' '}
                  <FontAwesomeIcon icon={getSortIconByFieldName('pain')} />
                </th>
                <th className="hand" onClick={sort('vaginalDischarge')}>
                  <Translate contentKey="tinyMedicRestApp.gynaecHistory.vaginalDischarge">Vaginal Discharge</Translate>{' '}
                  <FontAwesomeIcon icon={getSortIconByFieldName('vaginalDischarge')} />
                </th>
                <th className="hand" onClick={sort('endOfMenopause')}>
                  <Translate contentKey="tinyMedicRestApp.gynaecHistory.endOfMenopause">End Of Menopause</Translate>{' '}
                  <FontAwesomeIcon icon={getSortIconByFieldName('endOfMenopause')} />
                </th>
                <th className="hand" onClick={sort('imb')}>
                  <Translate contentKey="tinyMedicRestApp.gynaecHistory.imb">Imb</Translate>{' '}
                  <FontAwesomeIcon icon={getSortIconByFieldName('imb')} />
                </th>
                <th className="hand" onClick={sort('papSmear')}>
                  <Translate contentKey="tinyMedicRestApp.gynaecHistory.papSmear">Pap Smear</Translate>{' '}
                  <FontAwesomeIcon icon={getSortIconByFieldName('papSmear')} />
                </th>
                <th className="hand" onClick={sort('papSmearResult')}>
                  <Translate contentKey="tinyMedicRestApp.gynaecHistory.papSmearResult">Pap Smear Result</Translate>{' '}
                  <FontAwesomeIcon icon={getSortIconByFieldName('papSmearResult')} />
                </th>
                <th className="hand" onClick={sort('papSmearDate')}>
                  <Translate contentKey="tinyMedicRestApp.gynaecHistory.papSmearDate">Pap Smear Date</Translate>{' '}
                  <FontAwesomeIcon icon={getSortIconByFieldName('papSmearDate')} />
                </th>
                <th className="hand" onClick={sort('infertilityHist')}>
                  <Translate contentKey="tinyMedicRestApp.gynaecHistory.infertilityHist">Infertility Hist</Translate>{' '}
                  <FontAwesomeIcon icon={getSortIconByFieldName('infertilityHist')} />
                </th>
                <th className="hand" onClick={sort('breastFeeding')}>
                  <Translate contentKey="tinyMedicRestApp.gynaecHistory.breastFeeding">Breast Feeding</Translate>{' '}
                  <FontAwesomeIcon icon={getSortIconByFieldName('breastFeeding')} />
                </th>
                <th className="hand" onClick={sort('historyOfDES')}>
                  <Translate contentKey="tinyMedicRestApp.gynaecHistory.historyOfDES">History Of DES</Translate>{' '}
                  <FontAwesomeIcon icon={getSortIconByFieldName('historyOfDES')} />
                </th>
                <th className="hand" onClick={sort('desObservation')}>
                  <Translate contentKey="tinyMedicRestApp.gynaecHistory.desObservation">Des Observation</Translate>{' '}
                  <FontAwesomeIcon icon={getSortIconByFieldName('desObservation')} />
                </th>
                <th className="hand" onClick={sort('desDate')}>
                  <Translate contentKey="tinyMedicRestApp.gynaecHistory.desDate">Des Date</Translate>{' '}
                  <FontAwesomeIcon icon={getSortIconByFieldName('desDate')} />
                </th>
                <th className="hand" onClick={sort('sbe')}>
                  <Translate contentKey="tinyMedicRestApp.gynaecHistory.sbe">Sbe</Translate>{' '}
                  <FontAwesomeIcon icon={getSortIconByFieldName('sbe')} />
                </th>
                <th className="hand" onClick={sort('sbeObsv')}>
                  <Translate contentKey="tinyMedicRestApp.gynaecHistory.sbeObsv">Sbe Obsv</Translate>{' '}
                  <FontAwesomeIcon icon={getSortIconByFieldName('sbeObsv')} />
                </th>
                <th className="hand" onClick={sort('sbeDate')}>
                  <Translate contentKey="tinyMedicRestApp.gynaecHistory.sbeDate">Sbe Date</Translate>{' '}
                  <FontAwesomeIcon icon={getSortIconByFieldName('sbeDate')} />
                </th>
                <th className="hand" onClick={sort('momogram')}>
                  <Translate contentKey="tinyMedicRestApp.gynaecHistory.momogram">Momogram</Translate>{' '}
                  <FontAwesomeIcon icon={getSortIconByFieldName('momogram')} />
                </th>
                <th className="hand" onClick={sort('momogramObsv')}>
                  <Translate contentKey="tinyMedicRestApp.gynaecHistory.momogramObsv">Momogram Obsv</Translate>{' '}
                  <FontAwesomeIcon icon={getSortIconByFieldName('momogramObsv')} />
                </th>
                <th className="hand" onClick={sort('mamogramDate')}>
                  <Translate contentKey="tinyMedicRestApp.gynaecHistory.mamogramDate">Mamogram Date</Translate>{' '}
                  <FontAwesomeIcon icon={getSortIconByFieldName('mamogramDate')} />
                </th>
                <th className="hand" onClick={sort('active')}>
                  <Translate contentKey="tinyMedicRestApp.gynaecHistory.active">Active</Translate>{' '}
                  <FontAwesomeIcon icon={getSortIconByFieldName('active')} />
                </th>
                <th className="hand" onClick={sort('draft')}>
                  <Translate contentKey="tinyMedicRestApp.gynaecHistory.draft">Draft</Translate>{' '}
                  <FontAwesomeIcon icon={getSortIconByFieldName('draft')} />
                </th>
                <th className="hand" onClick={sort('cursor')}>
                  <Translate contentKey="tinyMedicRestApp.gynaecHistory.cursor">Cursor</Translate>{' '}
                  <FontAwesomeIcon icon={getSortIconByFieldName('cursor')} />
                </th>
                <th className="hand" onClick={sort('lastUpdated')}>
                  <Translate contentKey="tinyMedicRestApp.gynaecHistory.lastUpdated">Last Updated</Translate>{' '}
                  <FontAwesomeIcon icon={getSortIconByFieldName('lastUpdated')} />
                </th>
                <th className="hand" onClick={sort('microSec')}>
                  <Translate contentKey="tinyMedicRestApp.gynaecHistory.microSec">Micro Sec</Translate>{' '}
                  <FontAwesomeIcon icon={getSortIconByFieldName('microSec')} />
                </th>
                <th className="hand" onClick={sort('timestampEntry')}>
                  <Translate contentKey="tinyMedicRestApp.gynaecHistory.timestampEntry">Timestamp Entry</Translate>{' '}
                  <FontAwesomeIcon icon={getSortIconByFieldName('timestampEntry')} />
                </th>
                <th>
                  <Translate contentKey="tinyMedicRestApp.gynaecHistory.patient">Patient</Translate> <FontAwesomeIcon icon="sort" />
                </th>
                <th />
              </tr>
            </thead>
            <tbody>
              {gynaecHistoryList.map((gynaecHistory, i) => (
                <tr key={`entity-${i}`} data-cy="entityTable">
                  <td>
                    <Button tag={Link} to={`/gynaec-history/${gynaecHistory.id}`} color="link" size="sm">
                      {gynaecHistory.id}
                    </Button>
                  </td>
                  <td>{gynaecHistory.lmp}</td>
                  <td>{gynaecHistory.menarche}</td>
                  <td>{gynaecHistory.periodRegular}</td>
                  <td>{gynaecHistory.periodCycleInterval}</td>
                  <td>{gynaecHistory.parity}</td>
                  <td>{gynaecHistory.loss}</td>
                  <td>{gynaecHistory.pain}</td>
                  <td>{gynaecHistory.vaginalDischarge}</td>
                  <td>{gynaecHistory.endOfMenopause}</td>
                  <td>{gynaecHistory.imb ? 'true' : 'false'}</td>
                  <td>{gynaecHistory.papSmear ? 'true' : 'false'}</td>
                  <td>{gynaecHistory.papSmearResult}</td>
                  <td>{gynaecHistory.papSmearDate}</td>
                  <td>{gynaecHistory.infertilityHist ? 'true' : 'false'}</td>
                  <td>{gynaecHistory.breastFeeding ? 'true' : 'false'}</td>
                  <td>{gynaecHistory.historyOfDES ? 'true' : 'false'}</td>
                  <td>{gynaecHistory.desObservation}</td>
                  <td>{gynaecHistory.desDate}</td>
                  <td>{gynaecHistory.sbe ? 'true' : 'false'}</td>
                  <td>{gynaecHistory.sbeObsv}</td>
                  <td>{gynaecHistory.sbeDate}</td>
                  <td>{gynaecHistory.momogram ? 'true' : 'false'}</td>
                  <td>{gynaecHistory.momogramObsv}</td>
                  <td>{gynaecHistory.mamogramDate}</td>
                  <td>{gynaecHistory.active ? 'true' : 'false'}</td>
                  <td>{gynaecHistory.draft ? 'true' : 'false'}</td>
                  <td>{gynaecHistory.cursor}</td>
                  <td>{gynaecHistory.lastUpdated}</td>
                  <td>{gynaecHistory.microSec}</td>
                  <td>{gynaecHistory.timestampEntry}</td>
                  <td>
                    {gynaecHistory.patient ? <Link to={`/gluco-user/${gynaecHistory.patient.id}`}>{gynaecHistory.patient.id}</Link> : ''}
                  </td>
                  <td className="text-end">
                    <div className="btn-group flex-btn-group-container">
                      <Button tag={Link} to={`/gynaec-history/${gynaecHistory.id}`} color="info" size="sm" data-cy="entityDetailsButton">
                        <FontAwesomeIcon icon="eye" />{' '}
                        <span className="d-none d-md-inline">
                          <Translate contentKey="entity.action.view">View</Translate>
                        </span>
                      </Button>
                      <Button
                        tag={Link}
                        to={`/gynaec-history/${gynaecHistory.id}/edit?page=${paginationState.activePage}&sort=${paginationState.sort},${paginationState.order}`}
                        color="primary"
                        size="sm"
                        data-cy="entityEditButton"
                      >
                        <FontAwesomeIcon icon="pencil-alt" />{' '}
                        <span className="d-none d-md-inline">
                          <Translate contentKey="entity.action.edit">Edit</Translate>
                        </span>
                      </Button>
                      <Button
                        onClick={() =>
                          (window.location.href = `/gynaec-history/${gynaecHistory.id}/delete?page=${paginationState.activePage}&sort=${paginationState.sort},${paginationState.order}`)
                        }
                        color="danger"
                        size="sm"
                        data-cy="entityDeleteButton"
                      >
                        <FontAwesomeIcon icon="trash" />{' '}
                        <span className="d-none d-md-inline">
                          <Translate contentKey="entity.action.delete">Delete</Translate>
                        </span>
                      </Button>
                    </div>
                  </td>
                </tr>
              ))}
            </tbody>
          </Table>
        ) : (
          !loading && (
            <div className="alert alert-warning">
              <Translate contentKey="tinyMedicRestApp.gynaecHistory.home.notFound">No Gynaec Histories found</Translate>
            </div>
          )
        )}
      </div>
      {totalItems ? (
        <div className={gynaecHistoryList && gynaecHistoryList.length > 0 ? '' : 'd-none'}>
          <div className="justify-content-center d-flex">
            <JhiItemCount page={paginationState.activePage} total={totalItems} itemsPerPage={paginationState.itemsPerPage} i18nEnabled />
          </div>
          <div className="justify-content-center d-flex">
            <JhiPagination
              activePage={paginationState.activePage}
              onSelect={handlePagination}
              maxButtons={5}
              itemsPerPage={paginationState.itemsPerPage}
              totalItems={totalItems}
            />
          </div>
        </div>
      ) : (
        ''
      )}
    </div>
  );
};

export default GynaecHistory;
